import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

const ExportStatisticsModal = ({
  isOpen,
  handleExportXLS,
  handleExportXML,
  handleExportCSV,
  exportFields,
  handleClose,
}) => {
  const [selectedFormat, setSelectedFormat] = useState(null);

  const handleFormatSelect = (format) => {
    setSelectedFormat(format);
  };

  const handleExport = () => {
    if (selectedFormat === 'xls') {
      handleExportXLS();
    } else if (selectedFormat === 'xml') {
      handleExportXML();
    } else if (selectedFormat === 'csv') {
      handleExportCSV();
    }
    handleClose();
  };

  return (
    <Modal
      backdrop="static"
      isOpen={isOpen}
      toggle={handleClose}
      centered
      autoFocus
      className="export-statistics-modal"
    >
      <ModalHeader toggle={handleClose}>
        <FormattedMessage id="statistics.export.title" defaultMessage="Экспорт статистики" />
      </ModalHeader>

      <ModalBody>
        <div className="statistics-export-controls">
          <Button
            color={selectedFormat === 'xls' ? 'primary' : 'light'}
            onClick={() => handleFormatSelect('xls')}
          >
            XLS
          </Button>
          <Button
            color={selectedFormat === 'xml' ? 'primary' : 'light'}
            onClick={() => handleFormatSelect('xml')}
          >
            XML
          </Button>
          <Button
            color={selectedFormat === 'csv' ? 'primary' : 'light'}
            onClick={() => handleFormatSelect('csv')}
          >
            CSV
          </Button>
        </div>
        {exportFields}
      </ModalBody>

      <ModalFooter>
        <button type="button" className="btn btn-secondary" onClick={handleClose}>
          <FormattedMessage id="statistics.export.button-cancel" defaultMessage="Отмена" />
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleExport}
          disabled={!selectedFormat}
        >
          <FormattedMessage id="statistics.export.button" defaultMessage="Сохранить" />
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default ExportStatisticsModal;
